import * as React from 'react';

function usePrevious<T>(value: T, defaultValue?: T) {
  const ref = React.useRef<T>(value || defaultValue);

  React.useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
}
export default usePrevious;
